import React from 'react';
import API from "../utils/API";
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { checkDNI } from '../utils/DNI';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import esLocale from "date-fns/locale/es";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const styles = theme => ({
  paper: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backdropFilter: "blur(10px)",
    backgroundColor: 'rgba(255,255,255,0.3)',
    borderRadius: "4px"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  background: {
      width:100+"vw",
      height:100+"vh",
      background: "url('/images/backgrounds/1.jpeg') no-repeat",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      overflow: "auto",
      padding: "40px 0"
  }
});

class Register extends React.Component{

  constructor(props) {

      super(props);
      this.state = {user: '', pass: '', nombre:'', apellidos:'', genero: null, email:'', email_repeat:'', telefono:'', dni:'', passwordRepeat:'', fecha_nacimiento:null, id_image:(Math.floor(Math.random() * 6) + 1)};
      this.handleInputChange = this.handleInputChange.bind(this);
      this.registrarNuevoUsuario = this.registrarNuevoUsuario.bind(this);
      this.changeGenero = this.changeGenero.bind(this);
  }
  
  handleInputChange(event) {
    const target = event.target;
    const value = target.value.trim();
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  changeGenero(event){
    this.setState({genero:event.target.value});
  }

  async registrarNuevoUsuario(event) {
    event.preventDefault();
    if(this.state.pass.length < 5)
    {
      this.setState({"mensaje_error":"La contraseña debe tener mínimo 5 caracteres"});
      return;
    }
    if(!checkDNI(this.state.dni)){
      this.setState({"mensaje_error":"El dni introducido es inválido."});
      return;
    }
    if(this.state.telefono.length < 9)
    {
      this.setState({"mensaje_error":"Porfavor, introduzca un teléfono válido"});
      return;
    }
    try{
      let result = await API.post('/user', this.state);
      this.setState({"status":result.data.status});
      if(this.state.status==="ok"){
        this.setState({"mensaje":"Gracias por registrarte, accede a tu login"});
        let auth = await API.post('/login', {username:this.state.user, password:this.state.pass});
        this.setState({"status":auth.data.status});
        if (auth.data.status==="ok"){
          console.log(auth.data.accessToken);
          localStorage.setItem("token", auth.data.accessToken);
          this.props.history.push("/deportes");
        }else{
          //Show error 
          localStorage.setItem("token", "");
          this.setState({"mensaje_error":auth.data.message});
        }
      }else{
        this.setState({"mensaje_error":result.data.message});
      }
    }catch(e)
    {
      this.setState({"status":"ko"});
      this.setState({"mensaje_error":"Error de conexión."});
    }
  }

  render() {
  
    const  classes  = this.props.classes;
    const { t } = this.props;
    return (

      <div className={classes.background} style={{backgroundImage: "url('/images/backgrounds/"+this.state.id_image+".jpeg')"}}>
              <Container component="main" maxWidth="sm">
                <CssBaseline />
                <div className={classes.paper}>
                    <img alt="Logo" src="images/logos.png"/>
                    <Typography component="h1" variant="h5">
                    {t('Nuevo Registro')}
                    </Typography>
                    <form className={classes.form} noValidate>
                      <Grid container spacing={2}>
                        <Grid item xs>
                          <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="nombre"
                              label={t("Nombre")}
                              name="nombre"
                              autoComplete="Nombre"
                              autoFocus
                              onChange={this.handleInputChange}
                          />
                              <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="apellidos"
                              label={t("Apellidos")}
                              name="apellidos"
                              autoComplete="Apellido"
                              autoFocus
                              onChange={this.handleInputChange}
                          />
                          <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="dni"
                              label={t("DNI")}
                              name="dni"
                              autoComplete="DNI"
                              autoFocus
                              onChange={this.handleInputChange}
                          />
                          <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="telefono"
                              label={t("Teléfono")}
                              name="telefono"
                              autoComplete="Teléfono"
                              autoFocus
                              onChange={this.handleInputChange}
                          />

                          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                            <KeyboardDatePicker
                              //disableToolbar
                              //variant="inline"
                              inputVariant="outlined"
                              format="dd/MM/yyyy"
                              //margin="normal"
                              id="date-picker-inline"
                              label={t("Fecha de nacimiento")}
                              value={this.state.fecha_nacimiento}
                              onChange={(e)=>{this.setState({fecha_nacimiento: e})}}
                              style={{marginTop:"16px"}}
                              /*KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}*/
                            />
                          </MuiPickersUtilsProvider>
                          <FormControl variant="outlined" fullWidth style={{marginTop:"16px"}}>
                            <InputLabel id="genero-label">{t("Género")}</InputLabel>
                            <Select
                              labelId="genero-label"
                              id="genero"
                              value={this.state.genero}
                              onChange={this.changeGenero}
                              label={t("Género")}
                            >
                              <MenuItem value={1}>Hombre</MenuItem>
                              <MenuItem value={2}>Mujer</MenuItem>
                              <MenuItem value={3}>Persona no binaria</MenuItem>
                            </Select>
                          </FormControl>

                        </Grid>
                        <Grid item xs>
                        <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="email"
                              label={t("Correo electrónico")}
                              name="email"
                              autoComplete="Correo electrónico"
                              autoFocus
                              onChange={this.handleInputChange}
                          />
                        <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="email_repeat"
                              label={t("Repite tu correo electrónico")}
                              name="email_repeat"
                              autoComplete="Repite tu correo electrónico"
                              error={this.state.email !== this.state.email_repeat}
                              autoFocus
                              onChange={this.handleInputChange}
                          />
                          <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="user"
                              label={t('Nombre de usuario')}
                              name="user"
                              autoComplete="Nombre de usuario"
                              autoFocus
                              onChange={this.handleInputChange}
                          />
                          <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              name="pass"
                              label={t('Password')}
                              type="password"
                              id="pass"
                              error={this.state.pass.length > 0 && this.state.pass.length < 5}
                              //helperText={this.state.pass.length < 5? "Mínimo 5 caracteres":""}
                              autoComplete="password"
                              onChange={this.handleInputChange}
                          />
                              <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              error={this.state.pass !== this.state.passwordRepeat}
                              helperText={this.state.pass !== this.state.passwordRepeat ? 'Las contraseñas son diferente' : ' '}
                              name="passwordRepeat"
                              label={t("Repite Password")}
                              type="password"
                              id="passwordRepeat"
                              autoComplete="Repite Password"
                              onChange={this.handleInputChange}
                          />
                        </Grid>
                      </Grid>
                        
                      <p style={{color:"#f00"}}>{t(this.state.mensaje_error)}</p>
                      <p style={{color:"#0f0"}}>{t(this.state.mensaje)}</p>

                        <Button
                        type="button"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={this.registrarNuevoUsuario}
                        >
                            {t("Crear Nuevo Usuario")}
                        </Button>

                    </form>
                </div>
            </Container>

        </div>
    );
  };
  
}

export default withTranslation()(withRouter(withStyles(styles)(Register)))